module.exports = __webpack_public_path__ + "media/images/svg/play-d0787f8e98c7973c9546c5ef79270a71.svg";